import {
    IEnvelopeDocusignConfig,
    IInserirEnvelopeBody,
    IInserirEnvelopeResponse,
} from "../../../Interfaces/Geral/Envelopes/EnvelopesInterface";

import Axios from "../../Config/API";
import Service from "../../Service";

export function InserirEnvelopeServices(requestBody: IInserirEnvelopeBody) {
    return Service(
        Axios.post<IInserirEnvelopeResponse>(
            `/home/envelope/insereenvelope`,
            requestBody
        )
    );
}

export function ListarConfigEnvelopeServices(idDocusignEnvelopeConfig: number) {
    return Service(
        Axios.get<Array<IEnvelopeDocusignConfig>>(
            `/home/configenvelope/listarconfigenvelopedoc?IdConfigEnvelope=${idDocusignEnvelopeConfig}`
        )
    );
}
